import { DATE_KEYS } from "./DateRangeFilter";
export var ListToBeSorted;
(function (ListToBeSorted) {
    ListToBeSorted[ListToBeSorted["Users"] = 0] = "Users";
    ListToBeSorted[ListToBeSorted["Admins"] = 1] = "Admins";
    ListToBeSorted[ListToBeSorted["Dealers"] = 2] = "Dealers";
    ListToBeSorted[ListToBeSorted["DealersGroups"] = 3] = "DealersGroups";
    ListToBeSorted[ListToBeSorted["Transporters"] = 4] = "Transporters";
    ListToBeSorted[ListToBeSorted["AddressBook"] = 5] = "AddressBook";
    ListToBeSorted[ListToBeSorted["DealerShipments"] = 6] = "DealerShipments";
    ListToBeSorted[ListToBeSorted["AdminShipments"] = 7] = "AdminShipments";
    ListToBeSorted[ListToBeSorted["Quotes"] = 8] = "Quotes";
    ListToBeSorted[ListToBeSorted["TransporterShipments"] = 9] = "TransporterShipments";
    ListToBeSorted[ListToBeSorted["TransporterLoads"] = 10] = "TransporterLoads";
    ListToBeSorted[ListToBeSorted["NissanDealers"] = 11] = "NissanDealers";
    ListToBeSorted[ListToBeSorted["NissanColors"] = 12] = "NissanColors";
    ListToBeSorted[ListToBeSorted["NissanModels"] = 13] = "NissanModels";
    ListToBeSorted[ListToBeSorted["NissanPrices"] = 14] = "NissanPrices";
    ListToBeSorted[ListToBeSorted["Payments"] = 15] = "Payments";
    ListToBeSorted[ListToBeSorted["NissanTenderFile"] = 16] = "NissanTenderFile";
    ListToBeSorted[ListToBeSorted["PricingHistory"] = 17] = "PricingHistory";
    ListToBeSorted[ListToBeSorted["TransporterReports"] = 18] = "TransporterReports";
    ListToBeSorted[ListToBeSorted["SecurePassLogs"] = 19] = "SecurePassLogs";
})(ListToBeSorted || (ListToBeSorted = {}));
